import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '45+',
  label: 'Active Projects'
}, {
  value: '28',
  label: 'Member States Served'
}, {
  value: '£180M',
  label: 'Total Investment'
}, {
  value: '150+',
  label: 'Contracts Awarded'
}];
export function StatsSection() {
  return <section className="bg-white py-16 border-y border-gray-border" data-id="element-190">
      <div className="max-w-7xl mx-auto px-4" data-id="element-191">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-192">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-193">
              <div className="text-4xl md:text-5xl font-bold text-au-green mb-2" data-id="element-194">
                {stat.value}
              </div>
              <div className="text-gray-600 font-medium" data-id="element-195">{stat.label}</div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}